import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {UserIconRequestParams} from "../../../widgets/wizard-widget/models/assets/user-icon.request-params";
import styles from "./popularity-rank.module.scss";
import classNames from "classnames";
import {SVGImage} from "../image/svg-image";

export class PlayerRatingProps extends BaseProps {
  size: Number;
  className: String;
}

export const PopularityRank = ({size, color, className, iconClassName, popularityRankText, shouldRenderPopularityRank}: PlayerRatingProps) => {
  const userIconProps = {
    src: new UserIconRequestParams(size, size),
    width: size,
    height: size,
    fillcolor: color,
    className: classNames(styles.icon, iconClassName)
  };

  return (
    shouldRenderPopularityRank ? <div className={classNames(className)}>
      <SVGImage {...userIconProps}/>
      {popularityRankText}
    </div> : null
  )
};